import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { createContext, useState, useContext } from 'react';
import '../../utils/responsive.es.js';
import { useKeyPressWithCallback } from '../../hooks/useKeyPress/useKeyPressWithCallback.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import { useEnhancedEffect } from '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import 'nanoid/non-secure';
import '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import Level from '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import { Portal } from '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import { ConditionalWrapper } from '../../primitives/ConditionalWrapper/ConditionalWrapper.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import { Overlay } from '../Overlay/Overlay.es.js';
import { DismissButton } from '../DismissButton/DismissButton.es.js';
import { Slide } from '../Slide/Slide.es.js';
import { TRANSITION_DURATION, Drawer as Drawer$2, Header as Header$1, Footer as Footer$1, Content as Content$1 } from './styled.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var DrawerContext =
/*#__PURE__*/
createContext({
  onClose: function onClose() {
    return void 0;
  },
  isDismissable: true
});

var Header = function Header(_ref) {
  var children = _ref.children,
      _ref$showCloseButton = _ref.showCloseButton,
      showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton;

  var _useContext = useContext(DrawerContext),
      onClose = _useContext.onClose,
      isDismissable = _useContext.isDismissable;

  return (
    /* @__PURE__ */
    React.createElement(Header$1, null,
    /* @__PURE__ */
    React.createElement(ConditionalWrapper, {
      condition: isDismissable && showCloseButton,
      wrapper: function wrapper(children2) {
        return (
          /* @__PURE__ */
          React.createElement(Level, null,
          /* @__PURE__ */
          React.createElement(Level.Left, null, children2),
          /* @__PURE__ */
          React.createElement(Level.Right, null,
          /* @__PURE__ */
          React.createElement(DismissButton, {
            variant: "subtle",
            kind: "minimal",
            onClick: onClose
          })))
        );
      }
    }, children))
  );
};

var Footer = function Footer(_a) {
  var _b = _a,
      children = _b.children,
      props = __objRest(_b, ["children"]);

  return (
    /* @__PURE__ */
    React.createElement(Footer$1, __spreadValues({}, props), children)
  );
};

var Content = function Content(_c) {
  var _d = _c,
      children = _d.children,
      props = __objRest(_d, ["children"]);

  return (
    /* @__PURE__ */
    React.createElement(Content$1, __spreadValues({}, props), children)
  );
};

var Drawer = function Drawer(_e) {
  var _f = _e,
      children = _f.children,
      _f$side = _f.side,
      side = _f$side === void 0 ? "bottom" : _f$side,
      _f$isFull = _f.isFull,
      isFull = _f$isFull === void 0 ? false : _f$isFull,
      _f$isVisible = _f.isVisible,
      isVisible = _f$isVisible === void 0 ? false : _f$isVisible,
      _f$onClose = _f.onClose,
      onClose = _f$onClose === void 0 ? function () {
    return void 0;
  } : _f$onClose,
      _f$isDismissable = _f.isDismissable,
      isDismissable = _f$isDismissable === void 0 ? true : _f$isDismissable,
      _f$zIndex = _f.zIndex,
      zIndex = _f$zIndex === void 0 ? 1e3 : _f$zIndex,
      props = __objRest(_f, ["children", "side", "isFull", "isVisible", "onClose", "isDismissable", "zIndex"]);

  var _useState = useState(true),
      isExited = _useState[0],
      setIsExited = _useState[1];

  var handleClose = function handleClose() {
    isDismissable && (onClose == null ? void 0 : onClose());
  };

  var handleEnter = function handleEnter() {
    setIsExited(false);
  };

  var handleExited = function handleExited() {
    setIsExited(true);
  };

  useKeyPressWithCallback("Escape", handleClose);
  useEnhancedEffect(function () {
    if (!isVisible) {
      return;
    }

    var originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = "hidden";
    return function () {
      document.body.style.overflow = originalStyle;
    };
  }, [isVisible]);

  if (!isVisible && isExited) {
    return null;
  }

  return (
    /* @__PURE__ */
    React.createElement(DrawerContext.Provider, {
      value: {
        onClose: onClose,
        isDismissable: isDismissable
      }
    },
    /* @__PURE__ */
    React.createElement(Portal, {
      zIndex: zIndex
    },
    /* @__PURE__ */
    React.createElement(Overlay, {
      onClick: handleClose,
      isVisible: isVisible,
      position: "fixed"
    }),
    /* @__PURE__ */
    React.createElement(Slide, {
      in: isVisible,
      timeout: TRANSITION_DURATION,
      onEnter: handleEnter,
      onExited: handleExited,
      mountOnEnter: true,
      side: side
    },
    /* @__PURE__ */
    React.createElement(Drawer$2, __spreadValues({
      side: side,
      isFull: isFull,
      "aria-hidden": !isVisible
    }, props), children))))
  );
};

Drawer.Header = Header;
Drawer.Footer = Footer;
Drawer.Content = Content;
export { Drawer };